import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { useMediaQuery } from "../../hooks/useMediaQuery";

const statistics = [
  { id: "availability", value: "+24h", label: "Visible siempre" },
  { id: "delivery", value: "3-10", label: "días de entrega" },
  { id: "responsive", value: "100%", label: "responsive" },
];

const AboutStatistics = () => (
  <Reveal delay={0.2} className="mt-10 flex flex-wrap gap-x-10 gap-y-6">
    {statistics.map(({ id, value, label }) => (
      <div key={id}>
        <div data-testid={`about-${id}-value`} className="font-head text-3xl font-bold text-white">{value}</div>
        <div data-testid={`about-${id}-label`} className="mt-1 text-sm text-zinc-500">{label}</div>
      </div>
    ))}
  </Reveal>
);

const AboutContent = () => (
  <div className="lg:col-span-6">
    <Reveal><span className="text-sm font-medium uppercase tracking-[0.25em] text-[#00E5FF]">01 — Sobre nosotros</span></Reveal>
    <Reveal delay={0.05}>
      <h2 data-testid="about-heading" className="mt-5 font-head text-4xl font-light leading-tight tracking-tight text-white sm:text-5xl">
        Tu <span className="font-black">puerta de entrada</span> al mercado digital
      </h2>
    </Reveal>
    <Reveal delay={0.1}>
      <p className="mt-7 text-lg leading-relaxed text-zinc-400">
        En WebEssence diseñamos páginas web para negocios pequeños y medianos que aún no
        tienen presencia online, o que necesitan renovar la que ya tienen. Sabemos que muchos
        negocios locales pierden clientes simplemente por no ser visibles en internet.
      </p>
    </Reveal>
    <Reveal delay={0.15}>
      <p className="mt-5 text-lg leading-relaxed text-zinc-400">
        Por eso creamos webs profesionales, rápidas de entregar y pensadas para un único
        objetivo: que te encuentren y te elijan. No vendemos solo una página web. Vendemos tu
        puerta de entrada al mercado digital, disponible las 24 horas, incluso cuando tu negocio está cerrado.
      </p>
    </Reveal>
    <AboutStatistics />
  </div>
);

const AboutVisual = () => {
  const ref = useRef(null);
  const reducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);
  return (
    <div className="lg:col-span-6">
      <Reveal delay={0.1}>
        <div ref={ref} className="relative overflow-hidden rounded-3xl border border-white/10">
          <div className="we-glow right-0 top-0 h-40 w-40 bg-[#2979FF] opacity-40" />
          <motion.img data-testid="about-image" style={{ y: reducedMotion ? 0 : y }}
            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
            alt="Equipo de WebEssence trabajando en el diseño web de un negocio" loading="lazy"
            className="h-[440px] w-full scale-110 object-cover md:h-[540px]" />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-transparent to-transparent" />
        </div>
      </Reveal>
    </div>
  );
};

export const About = () => (
  <section id="sobre-nosotros" data-testid="about-section" className="relative mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-32">
    <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16"><AboutContent /><AboutVisual /></div>
  </section>
);